<script>
  const interval = 3000;
  let icon = "fas fa-spinner fa-pulse";
  let tag = "tag is-warning";
  let jobStatus = "Prüfe Status...";
  let clear;
  export let userInfo = undefined;
  let clicked = false;

  async function statusUpdate() {
    const res = await fetch("/api/checkjobstatus");
    const data = await res.json();
    jobStatus = obj.jobStatus.data;
  }

  $: {
    if (jobStatus === "Running") {
      icon = "fas fa-check-square";
      tag = "tag is-success";
    } else if (jobStatus === "Prüfe Status...") {
      icon = "fas fa-spinner fa-pulse";
      tag = "tag is-warning";
    } else {
      icon = "fas fa-exclamation-triangle";
      tag = "tag is-danger";
    }
    clearInterval(clear);
    clear = setInterval(statusUpdate, interval);
  }

  async function launchJob() {
    clicked = true;
    const res = await fetch("/api/startJob", { method: "POST", body: {} });
  }
</script>

<span class="navbar-item">
  <span class={tag}>
    <span class="icon">
      <i class={icon} />
    </span>
    <span>Service {jobStatus}</span>
  </span>
</span>
{#if clicked === false}
  {#if userInfo}
    {#if jobStatus === "Stopped"}
      <span class="navbar-item">
        <span
          class="button is-small is-rounded is-primary is-outlined"
          on:click={launchJob}
        >
          <span class="icon">
            <i class="fas fa-play" />
          </span>
          <span>Launch Service</span>
        </span>
      </span>
    {/if}
  {/if}
{/if}
